// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1hGac","header":"MergedInvoice_header__178C7"};